import React from 'react'
import { LoginForm } from '../../../components/Admin/Auth';


export function Auth() {
  return (
    <> 
      <LoginForm />
    </>
  )
}
